<template>
  <a-row :gutter="[16,16]">
    <a-col :span="24">
      <attributo-tabs
        :empleadoseleccionado="empleadoseleccionado"
      />
    </a-col>
  </a-row>
</template>
<script>
  export default {
    props: ['empleadoseleccionado']
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Empleados/Atributos.vue